import React, { useEffect, useMemo } from 'react';
import { translate } from '../../Services/translation';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getOrder } from '../../Actions/Order.action';
import Icon from '../Icon';
import OrderDetail from '../OrderDetail/OrderDetail';
import { breakpoint } from '../../styling/mixins/breakpoints';
import styled from 'styled-components';
import Button from '../Button';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { reorder } from '../../Services/Cart.service';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { getColor } from '../../styling/mixins/colors';
import { setError } from '../../Actions/Order.action';

const StyledMyPagesOrderDetail = styled.div`
  grid-column: span 3;

  .menu {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-bottom: 1.6rem;

    ${breakpoint('medium')} {
      gap: unset;
      flex-direction: row;
      justify-content: space-between;
    }

    ${breakpoint('xlarge')} {
      margin-bottom: 2.4rem;
    }
  }

  .btn--back {
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    ${fontFamilyBold}

    ${breakpoint('medium')} {
      width: unset;
    }
  }

  .btn__wrapper {
    display: flex;
    gap: 0.8rem;

    ${breakpoint('medium')} {
      gap: 2.4rem;
    }

    button {
      align-items: center;
      justify-content: center;
      display: flex;
      width: 50%;
      ${fontFamilyBold}

      ${breakpoint('medium')} {
        width: unset;
      }
    }
  }

  .order-icon {
    width: 16px;
    height: 16px;
    margin-right: 0.8rem;
  }

  .error {
    ${text('medium')};
    color: ${getColor('alert')};
  }
`;

const MyPagesOrderDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { order, errors = {} } = useTypedSelector(
    (state) => state.myPage.orders
  );
  const generalError = useMemo(
    () => (errors && errors['general']?.length ? errors['general'][0] : null),
    [errors]
  );

  useEffect(() => {
    if (!order) {
      dispatch(getOrder(id));
    }
  }, []);

  const addOrderToCart = async () => {
    try {
      const cart = await reorder(id);
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };

  return (
    <StyledMyPagesOrderDetail>
      <div className="menu">
        <Button
          btnType="outlined"
          btnSize="small"
          className="btn--back"
          onClick={() => {
            dispatch(setError({ general: [] }));
            navigate(-1);
          }}
        >
          <Icon name="chevron-left" className="order-icon" />
          {translate('mypage.order.allorders')}
        </Button>
        <div className="btn__wrapper">
          <Button btnType="outlined" btnSize="small" onClick={addOrderToCart}>
            <Icon name="refresh" className="order-icon" />
            {translate('mypage.order.addtocart')}
          </Button>
          <Button btnType="outlined" btnSize="small">
            <Icon name="print" className="order-icon" />
            {translate('mypage.order.print')}
          </Button>
        </div>
      </div>
      {generalError && <p className="error">{generalError}</p>}
      {order ? <OrderDetail order={order} isConfirmation={false} /> : null}
    </StyledMyPagesOrderDetail>
  );
};

export default MyPagesOrderDetail;
